import { SVGProps } from "react";

const ArrowRightExtraThin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={9}
    height={16}
    viewBox="0 0 9 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.4248 14.6004L6.85814 9.16706C7.49981 8.52539 7.49981 7.47539 6.85814 6.83372L1.4248 1.40039"
      stroke={props.color || "black"}
      strokeOpacity={props.opacity || 0.3}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowRightExtraThin;
